var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon"},[(_vm.type === 'workfolder')?_c('workfolder-icon'):(_vm.type === 'videotrack')?_c('videotrack-icon'):(_vm.type === 'track')?_c('track-icon'):(_vm.type === 'route')?_c('route-icon'):(_vm.type === 'poi')?_c('poi-icon'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b11ca9b6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/suggestions/DataIcon.vue
// module id = null
// module chunks = 